import React from 'react'
import { Layout, Stack, Main, Sidebar } from '@layout'
import PageTitle from '@components/PageTitle'
import Divider from '@components/Divider'
import Seo from '@widgets/Seo'
import ContactForm from '@widgets/ContactForm'
import ContactInfo from '@widgets/ContactInfo'
import Commitment from '@widgets/Commitment'

const disclaimer = props => (
  <Layout {...props}>
    <Seo title='Disclaimer and Imprint' />
    <Divider />
    <Stack>
    <Main>
        <PageTitle
          header="Disclaimer and Imprint for Psychtan"
        />
        <Divider />
        <h3>Disclaimer</h3>
        <p>All articles, tutorials, views and statements expressed on <a href="https://Psychtan.com">Psychtan</a> are owned by Psychtan team(Us) and do not represent any opinions of any other entity.</p>

        <h3>Imprint</h3>
        <p>Psychtan.</p>
        <p>14121, Dar-Es-Salaam</p>
        <p>Tanzania</p>
        <p>Email: <mail to="Psychtan.co@gmail.com">Psychtan.co@gmail.com</mail></p>

        <h3>Images</h3>
        <p>Images used in this site are mainly from</p>
        <ul>
          <li><a href="https://unsplash.com/">https://unsplash.com/</a></li>
          <li><a href="https://pixabay.com/">https://pixabay.com/</a></li>
        </ul>
        <p>You can find the licence and credits to the images owners on the bottom of images in posts</p>

        <h3>Third party websites</h3>
        <p>Psychtan includes hyperlinks to, and details of third party websites. We are not reponsible for and not in control over the privacy policies and practices of third parties.</p>
        
      </Main>
      
    </Stack>
  </Layout>
)

export default disclaimer
